import * as moment from "moment"
import {BookingStatus} from "./BookingTypes"

export const bookingDateDisplayFormat = "D MMMM YYYY"

// This format is shared with the backend conversion functions, see time.kt
const bookingDateBackendFormat = "YYYY-MM-DD"

export function bookingDateToDisplayString(bookingDate: string) {
  return moment(bookingDate).format(bookingDateDisplayFormat)
}

export function momentBookingDateToBackendString(moment: moment.Moment) {
  return moment.format(bookingDateBackendFormat)
}

export function isAM(hour: number) {
  return hour < 12
}

export function bookingTimeToString(hour: number, minute: number) {
  return (
    twentyFourHourTo12(hour).toString() +
    ":" +
    padTimeValue(minute) +
    " " +
    (isAM(hour) ? "am" : "pm")
  )
}

export function padTimeValue(n: number) {
  return n < 10 ? "0" + n : `${n}`
}

function twentyFourHourTo12(hour: number) {
  if (hour === 0) {
    return 12
  } else if (hour <= 12) {
    return hour
  }
  return hour - 12
}

// The code here is somewhat a *repetition* of that in time.kt on the backend. The duplication is
// not ideal but the code on the frontend is just for booker convenience while the code on the
// backend is canonical.

// Considering the booking time:
// - If it is closer than 3 hours away, or in the past: too close.
// - If "now" is after 7pm on the day before the booking, and the booking is before 7am: too close.
export function bookingTimeTooClose(status: BookingStatus, now: moment.Moment) {
  const bookingTime = moment(status.bookingTimestamp)
  const lessThan3HoursBefore = now
    .clone()
    .add(3, "hours")
    .isAfter(bookingTime)
  const past7pmOnDayBefore = now.isAfter(status.bookingDayBefore7pm)
  const bookingTimeBefore7am = bookingTime.isBefore(status.bookingDay7am)

  return lessThan3HoursBefore || (past7pmOnDayBefore && bookingTimeBefore7am)
}

export const bookingTooCloseMsg = "It is now too late to set the booking to this time."

export const bookingNotesOnlyMsg =
  "It is now too late to save most changes to this booking." +
  "  But you can change the booking notes, the registered credit card or the promo code."

export const bookingInvoicedMsg = "This booking has already been invoiced."

export const bookingCancelledMsg = "This booking has been cancelled."

export const bookingHiddenMsg = "This booking has been hidden."



// WEBPACK FOOTER //
// ./src/model/time.ts